<template>
  <!-- modal -->
  <div class="dimed wrap">
    <div class="layer">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.Membership.Point.msg1') }}</div>
        <div class="ft-point">
          {{ $t('Modal.Membership.Point.msg2') }} {{ membersObj.point.MininumUnitOfUse.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          }}{{ $t('Modal.Membership.Point.msg12') }}
        </div>
        <div class="lyr-txt">{{ $t('Modal.Membership.Point.msg13') }} {{ membersObj.point.UnitOfUse.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}P</div>
        <div class="lyr-txt">{{ $t('Modal.Membership.Point.msg3') }}</div>
      </div>
      <div class="layer__body">
        <div class="flex-row">
          <div class="lyr-point-left">
            <div class="lst-order--point">
              <dl>
                <dt>{{ $t('Modal.Membership.Point.msg4') }}</dt>
                <dd>{{ $displayUprc(totalPrice) }}</dd>
              </dl>
              <dl>
                <dt>{{ $t('Modal.Membership.Point.msg5') }}</dt>
                <dd>{{ membersObj.point.UPOINT.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}P</dd>
              </dl>
              <dl>
                <dt>{{ $t('Modal.Membership.Point.msg20') }}</dt>
                <dd>{{ membersObj.point.LimitOfUsePoint.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}P</dd>
              </dl>
              <dl>
                <dt>{{ $t('Modal.Membership.Point.msg6') }}</dt>
                <dd class="use-point">{{ usePoint.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}P</dd>
              </dl>
            </div>
            <!-- <button class="btn btn--use-point">결제 총 금액 포인트 사용</button> -->
            <button class="btn btn--use-point" :class="{active: usePoint == totalPrice}">{{ $t('Modal.Membership.Point.msg7') }}</button>
          </div>
          <div class="lyr-point-right">
            <div class="keypad-wrap">
              <div class="keypad keypad--white">
                <button class="btn-anim" @mouseup="setRecipt(1)">1</button>
                <button class="btn-anim" @mouseup="setRecipt(2)">2</button>
                <button class="btn-anim" @mouseup="setRecipt(3)">3</button>
                <button class="btn-anim" @mouseup="setRecipt(4)">4</button>
                <button class="btn-anim" @mouseup="setRecipt(5)">5</button>
                <button class="btn-anim" @mouseup="setRecipt(6)">6</button>
                <button class="btn-anim" @mouseup="setRecipt(7)">7</button>
                <button class="btn-anim" @mouseup="setRecipt(8)">8</button>
                <button class="btn-anim" @mouseup="setRecipt(9)">9</button>
                <button @mouseup="setRecipt(10)" class="delete btn-anim">{{ $t('Modal.Membership.Point.msg8') }}</button>
                <button class="btn-anim" @mouseup="setRecipt(0)">0</button>
                <button @mouseup="setRecipt(-1)" class="btn-back btn-anim">{{ $t('Modal.Membership.Point.msg9') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layer__button">
        <button class="btn btn--cancel" @mouseup="$emit('cancelPoint')">{{ $t('Modal.Membership.Point.msg10') }}</button>
        <button
          class="btn btn--submit"
          @mouseup="useMembersPoint(true)"
          :disabled="usePoint < membersObj.point.MininumUnitOfUse || usePoint > membersObj.point.UPOINT || totalPrice == 0"
        >
          {{ $t('Modal.Membership.Point.msg11') }}
        </button>
      </div>
    </div>
    <AlertVue :text="this.text" v-if="alertYn" @setYes="alertYn = false" />

    <div class="dimed wrap" v-if="alertConfirmYn">
      <div class="layer layer--sm">
        <div class="layer__body">
          <div class="ft--xlg ft--bold">{{ $t('Modal.Membership.Point.msg18') }}</div>
          <div class="ft--xlg ft--bold">{{ $t('Modal.Membership.Point.msg19') }}</div>
        </div>
        <div class="layer__button">
          <button class="btn btn--cancel" @mouseup="alertConfirmYn = false">{{ $t('Modal.AlertConfirm.msg1') }}</button>
          <button class="btn btn--submit" @mouseup="$emit('useMembersPoint', usePoint)">{{ $t('Modal.AlertConfirm.msg2') }}</button>
        </div>
      </div>
    </div>

    <MembershipPwCheck v-if="membershipPwCheckYn" @membersPwClose="closeMembersPw" @setMembersPw="setMembersPw" />
  </div>
</template>
<script>
import membershipPwCheck from '@/components/modal/payment/MembershipPwCheck.vue';
import alertVue from '@/components/modal/alert/AlertSuccess.vue';

export default {
  name: 'membersPoint',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      usePoint: 0,
      text: '',
      alertYn: false,
      LimitOfUsePoint: 15000,
      alertConfirmYn: false,
      membershipPwCheckYn: false,
      membershipPw: '',
    };
  },
  mounted() {},
  props: {
    currUnitText: String,
    membersObj: Object,
    totalPrice: Number,
  },
  methods: {
    setRecipt(num) {
      if (this.usePoint == 0) this.usePoint = '';
      if (num == 10) this.usePoint = 0;
      else if (num < 0) {
        this.usePoint = this.usePoint.slice(0, -1);
        if (this.usePoint == '') this.usePoint = 0;
      } else {
        this.usePoint += num + '';
        // if (this.usePoint >= this.totalPrice) {
        //   this.usePoint = this.totalPrice + '';
        //   return false;
        // }
        if (this.usePoint > this.membersObj.point) {
          this.usePoint > this.membersObj.point + '';
          return false;
        }
      }
    },
    useMembersPoint(pw) {
      if (pw && this.membersObj.point.PwInUse && Number(this.usePoint) >= Number(this.membersObj.point.PwUsageCriteriaAmt)) {
        this.membershipPwCheckYn = true;
      } else {
        if (Number(this.usePoint) % Number(this.membersObj.point.UnitOfUse) > 0) {
          this.text =
            this.$t('Modal.Membership.Point.msg14') +
            this.membersObj.point.UnitOfUse.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
            this.$t('Modal.Membership.Point.msg15');
          this.alertYn = true;
        } else if (Number(this.membersObj.point.LimitOfUsePoint) < Number(this.usePoint)) {
          this.text =
            this.$t('Modal.Membership.Point.msg16') +
            this.membersObj.point.LimitOfUsePoint.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
            this.$t('Modal.Membership.Point.msg17');
          this.alertYn = true;
        } else if (Number(this.totalPrice) < Number(this.usePoint)) {
          this.alertConfirmYn = true;
        } else {
          this.$emit('useMembersPoint', this.usePoint);
        }
      }
    },
    //멤버쉽 패스워드
    setMembersPw(pw) {
      this.membershipPw = pw;
      this.membershipPwCheckYn = false;
      this.$emit('setMembersPw', pw);
      this.useMembersPoint(false);
    },
    closeMembersPw() {
      this.membershipPw = '';
      this.membershipPwCheckYn = false;
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
  components: {
    AlertVue: alertVue,
    MembershipPwCheck: membershipPwCheck,
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/pages/payment.css" scoped></style>
<style src="@/assets/css/user/pages/keypad.css" scoped></style>
<style scoped>
@media (-webkit-device-pixel-ratio: 1.25) {
  .ft-point {
    font-size: 1.2em !important;
  }
}
.layer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 74%;
  height: max-content;
  padding: 3.6vh 0 8vh;
  background: var(--bg-color);
  border-radius: var(--radius-modal);
}

.layer__header {
  height: max-content;
  text-align: center;
  width: 100%;
  padding: 0 4vw;
}

.lyr-txt {
  font-weight: normal;
}

.layer__body {
  position: relative;
  min-height: 7.3vh;
  margin: 3vh 0;
  text-align: center;
  padding: 0 6vw;
}
/* common.css에 있는 .layer, .layer__header, .lyr-txt, .layer__body 클래스 스타일 변경 필수 */

.lyr-point-left {
  width: 44%;
}

.lyr-point-right {
  width: 51%;
}

.lst-order--point {
  width: 100%;
  text-align: left;
}

.lst-order--point dl {
  display: block;
  margin-bottom: 10px;
  font-size: 1.2em;
}

.lst-order--point dt {
  font-weight: normal;
}

.lst-order--point dd {
  margin-top: 10px;
  padding-right: var(--txt-pd20);
  font-size: 1.4em;
  font-weight: 600;
  height: 3.5vh;
  line-height: 3.5vh;
  border: 2px solid var(--border-color);
  border-radius: var(--radius);
  text-align: right;
}

.lst-order--point dd.use-point {
  border: none;
  background: var(--light-gray);
  color: var(--secondary-ft-color);
}

.btn--use-point {
  width: 100%;
  height: 3vh;
  font-weight: 600;
  color: var(--secondary-ft-color);
  border: 2px solid var(--border-color);
  border-radius: 10px;
}

.btn--use-point.active {
  background-color: #1a490171;
}
</style>
